'use strict';

var loadMiraklOffers = require('./loadMiraklOffers');
var paybright = require('core/checkout/paybright');

/**
 * Compute the product price and duties for display purpose
 * @param {Object} Duties Object.
 */
function updatePriceWithDuties(dutiesHtml) {
    var miraklProductData = $('#miraklbuybox').find('button.offer-add-to-cart').data('mirakl');
    if(miraklProductData && miraklProductData.price && miraklProductData.price.sales && miraklProductData.price.sales.value){
        updateMiraklPrice(miraklProductData.price.sales.value, dutiesHtml);
    }
}

$(document).on('mirakl:price:updated', function(e, dutiesHtml) {
    var miraklProductData = $('#miraklbuybox').find('button.offer-add-to-cart').data('mirakl');
    var isPriceRange = $('.product-secondary-section .prod-price .range');

    if ((isPriceRange.length < 0 || isPriceRange.data('is-price-range') !== true) && miraklProductData) {
        var productPrice = parseFloat($('.product-secondary-section .prod-price .js-final-sale-price').attr('data-unformatted-price'), 10);
        var duties = null, newProductPrice, dutiesMsg;
        var productDiscountPrice = miraklProductData && miraklProductData.price && miraklProductData.price.list && miraklProductData.price.list.value ? miraklProductData.price.list.value : '';
        var productDiscountPriceStr = productDiscountPrice ? $('body').hasClass('fr_CA') ? productDiscountPrice + ' $' : '$'+productDiscountPrice.toFixed(2) : '';
        if (dutiesHtml && $(dutiesHtml).filter('.duties-content') && $(dutiesHtml).filter('.duties-content').data('value')) {
            duties = parseFloat($(dutiesHtml).filter('.duties-content').attr('data-value'), 10);
            dutiesMsg = $(dutiesHtml).filter('.duties-content').attr('data-duties-msg')
        } else if ( $('#miraklbuybox').length > 0) {
            duties = parseFloat($('#miraklbuybox').find('.duties-content').attr('data-value'), 10);
            dutiesMsg = $('#miraklbuybox').find('.duties-content').attr('data-duties-msg');
        }
        var $listPrice = $('.product-secondary-section .prices .prod-price .list');
        if (productDiscountPrice === ''){
            $listPrice.addClass('d-none');
        }else{
            $listPrice.removeClass('d-none');
            if ($listPrice.length) {
                $listPrice.addClass('strike-through');
                $listPrice.find('.value').attr('content', productDiscountPrice);
            }
        }
        if (duties) {
            newProductPrice = productPrice - duties;
            var newProductPriceStr = $('body').hasClass('fr_CA') ? newProductPrice + ' $' : '$'+newProductPrice.toFixed(2);
            $('.product-secondary-section .prod-price .js-final-sale-price').text(newProductPriceStr);
            $('.product-secondary-section .prod-price .js-final-sale-price').data('unformatted-price', newProductPrice);

            var parentElement = $('div.prices');
            parentElement.find('span.duties').remove();
            parentElement.append('<span class="duties">' + dutiesMsg + '</span>');
        } else {
            var productPriceStr = $('body').hasClass('fr_CA') ? productPrice + ' $' : '$'+productPrice.toFixed(2);
            $('div.prices .duties').remove();
            $('.product-secondary-section .prod-price .js-final-sale-price').text(productPriceStr);
            $('.product-secondary-section .prod-price .js-final-sale-price').data('unformatted-price', productPrice);
        }
    }
});

/**
 * Updates the free shipping element
 */
function updateFreeShipping() {
    const freeShippingTextPDP = $(".mp-free-shipping-text-pdp");
    const freeShippingTextLink = $(".free-shipping-mp-link");
    const freeShippingMessage = $(".mp-dynamic-free-shipping-text").data("freeshippingmsg");
    const isFreeShippingAvailable = $(".mp-dynamic-free-shipping-text").data("isfreeshippingavailable");
    const freeShippingMPElementEffect = $(".shimmerBG-pdp-MP");
    const freeShippingLable = $(".free-shipping-mp-label");
    const dnone = 'd-none';
    if (freeShippingMPElementEffect.length > 0) freeShippingMPElementEffect.addClass(dnone);
    if (freeShippingLable.length > 0) {
        freeShippingLable.addClass('d-inline-flex');
        freeShippingLable.removeClass(dnone);
    }
    if(!freeShippingMessage || !freeShippingMessage.length) return;
    if (isFreeShippingAvailable) {
        if(freeShippingTextPDP) freeShippingTextPDP.text(freeShippingMessage);
        if(freeShippingTextLink) freeShippingTextLink.removeClass(dnone);
    } else {
        if(freeShippingTextPDP) freeShippingTextPDP.text(freeShippingMessage);
        if(freeShippingTextLink) freeShippingTextLink.addClass(dnone);
    }
}

/**
 * Updates the buybox and load offers when a variant is changed
 * @param {Object} response - The response from the ajax call(Product-Variant)
 */
function updateBuyBox(response) {
    var pdpPostalCodeSection = $(".shipping-option-postal-code");
    var freeShippingText = $(".free-ship-text-mp");
    var dnone="d-none";
    if (response.data && response.data.isMiraklEnabled && response.data.product && response.data.product.available) {
        if (pdpPostalCodeSection && pdpPostalCodeSection.length > 0 && pdpPostalCodeSection.hasClass(dnone)){
            pdpPostalCodeSection.removeClass(dnone);
        }
        if (freeShippingText && freeShippingText.length > 0 && freeShippingText.hasClass(dnone)) {
            freeShippingText.removeClass(dnone);
        }
        var miraklBuyBox = $('#miraklbuybox');
        var normalBuyBox = $('.buybox');
        if (response.data.callP11) {
            var buyBoxUrl = miraklBuyBox.data('buybox-url');
            buyBoxUrl += "?pid=" + response.data.product.id;
            $.ajax({
                url: buyBoxUrl,
                type: 'get',
                success: function (data) {
                    miraklBuyBox.empty();
                    miraklBuyBox.html(data);
                    var atcButton = miraklBuyBox.find('button.offer-add-to-cart');
                    var miraklData = atcButton.data('mirakl');
                    var miraklHudsonPoint = atcButton.data('hudson-point');
                    if (miraklHudsonPoint && !isNaN(miraklHudsonPoint)) {
                        $('.rewards-message-section .reward-est-point').text(parseInt(miraklHudsonPoint));
                    }
                    updatePriceWithDuties(data);
                    miraklBuyBox.removeClass(dnone);
                    normalBuyBox.addClass(dnone);
                    updateFreeShipping();
                    $.spinner().stop();
                },
                error: function (err) {
                    miraklBuyBox.addClass(dnone);
                    normalBuyBox.removeClass(dnone);
                    $.spinner().stop();
                }
            });
            miraklBuyBox.addClass(dnone);
            normalBuyBox.removeClass(dnone);
        } else {
            miraklBuyBox.addClass(dnone);
            normalBuyBox.removeClass(dnone);
        }
    }
    else {
        if (pdpPostalCodeSection && pdpPostalCodeSection.length > 0) {
            pdpPostalCodeSection && pdpPostalCodeSection.addClass(dnone);
        }
        if (freeShippingText && freeShippingText.length > 0) {
            freeShippingText && freeShippingText.addClass(dnone);
        }
    }
}
function fillAllOffersModalElement(selectedValueUrl, miraklOffersJson, productData) {
    if (typeof miraklOffersJson !== 'undefined' && miraklOffersJson.length) {
        $.ajax({
            url: selectedValueUrl,
            type: 'POST',
            data: {
                miraklOffersJson: JSON.stringify(miraklOffersJson),
                productDataJSON: JSON.stringify(productData)
            },
            success: function (data) {
                if (data.offersHtml !== '') {
                    $('.alloffers-modal-body').empty();
                    $('.alloffers-modal-body').html(data.offersHtml);
                    $('#allOffersModal').modal('show');
                    $.spinner().stop();
                }
            },
            error: function (err) {
                $.spinner().stop();
            }
        });
    }
    $.spinner().stop();
}
function fillSellerModalElement(selectedValueUrl, sellerId) {
    $.ajax({
        url: selectedValueUrl,
        method: 'POST',
        data: {
            sellerId: sellerId
        },
        success: function (data) {
            $('#sellerShippingReturnPolicyModal .seller-shipping-return-policy-modal-content').empty();
            $('#sellerShippingReturnPolicyModal .seller-shipping-return-policy-modal-content').html(data);
            $('#sellerShippingReturnPolicyModal').modal('show');
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
        }
    });
}

function updateMiraklHudsonPoint() {
    var atcButton = $('#miraklbuybox').find('button.offer-add-to-cart');
    if (atcButton.length > 0)
    {
        var miraklHudsonPoint = atcButton.data('hudson-point');
        if (miraklHudsonPoint && !isNaN(miraklHudsonPoint)) {
            $('.rewards-message-section .reward-est-point').text(parseInt(miraklHudsonPoint));
        }
    }
}
/**
 * Update attributes when the variant was changed + updateBuyBox function call
 */
function updateAttribute() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.product-set-detail').eq(0)) {
            if(response.container && response.container.prevObject.length > 0 && response.container.prevObject[0].classList.contains('quantity-select')) {
                $.spinner().stop();
                return;
            }
            updateBuyBox(response);
        }
        if(response && response.data && response.data.product && response.data.product.offerState) {
            var state = response.data.product.offerState;
            var stateDiv = $('.product-state');
            var newState = $('#offer-state-new');
            var newStateFr = $('#offer-state-new-fr');
            if (stateDiv.length === 0) return;
            if (newState.length === 0 || state === newState[0].value) {
                stateDiv[0].innerText = '';
            } else if (newStateFr.length === 0 || state === newStateFr[0].value) {
                stateDiv[0].innerText = '';
            } else {
                stateDiv[0].innerText = state;
            }
        }
        if (response.data.product.price.sales && (!('isMarketplaceProduct' in response.data.product) || !response.data.product.isMarketplaceProduct)) {
            paybright.togglePaybright(response.data.product.price.sales.value);
        }

    });
    $(document).on('click', '.seller-shipping-return-policy', function (e) {
        e.preventDefault();
        $.spinner().start();
        var selectedValueUrl = $(this).data('modalurl');
        var sellerId = $(this).data('sellerid');
        fillSellerModalElement(selectedValueUrl, sellerId);
    });
    $(document).on('click', '.open-all-offers-modal', function(e) {
        e.preventDefault();
        $.spinner().start();
        var selectedValueUrl = $(this).data('modalurl');
        var miraklOffersJson = $(this).data('mirakloffers');
        var productData = $(this).data('productdata');
        fillAllOffersModalElement(selectedValueUrl, miraklOffersJson, productData);
    });
    $(document).on('click', '.seller-tooltip-btn', function (e) {
        $('body').click();
    });
    var miraklData = $('#miraklbuybox').find('button.offer-add-to-cart').data('mirakl');
    if(miraklData){
        $('.product-secondary-section .prod-price .js-final-sale-price').html(miraklData.price.sales.formatAmount);
        $('.product-secondary-section .prod-price .js-final-sale-price').attr('data-unformatted-price', miraklData.price.sales.value);
    }

    updatePriceWithDuties();
    updateMiraklHudsonPoint();
}

function handleOfferState() {
    var offerStateDiv = $('.bestoffer-state');
    if(offerStateDiv.length > 0){
        var offerState = offerStateDiv.detach();
        offerState.removeClass('d-none');
        var state;
        if ('innerText' in offerState && offerState.innerText !== null) {
            state = offerState.innerText.toLocaleLowerCase()
        } else {
            state = '';
        }
        // We want to hide the state when is one of these.
        if(state.includes('new') || state.includes('neuf') || state.includes('nouveauté')) return;
        $('.attributes').before(offerState);
    }
}

function updateMiraklPrice(priceValue, dutiesHtml) {
    var prodPrice = $('.product-secondary-section .prod-price');
    var newPrice = $('.mirakl-updated-price');
    if (prodPrice.length > 0 && newPrice.length > 0) {
        newPrice.detach();
        newPrice.removeClass('d-none');
        prodPrice.replaceWith(newPrice.html());
        $(document).trigger('mirakl:price:updated', dutiesHtml);
        paybright.togglePaybright(priceValue);
    }
    $(document).trigger('mirakl:price:updated', dutiesHtml);
}

$(document).on('click', '.shipping-returns a', function (e) {
    e.preventDefault();
    $.spinner().start();
    $.ajax({
        url: this.href,
        method: 'GET',
        success: function (data) {
            const $shippingReturnsEl = $(data).find('.m-shop-page');
            $shippingReturnsEl.find('.mkp-shop-upper-content-left').remove();
            $shippingReturnsEl.append($('<div>' + data + '</div>').find('link[href*="/css/shopPage.css"]'));
            $shippingReturnsEl.find('.shipping-return-title').removeClass('d-none').addClass('mb-1');
            $shippingReturnsEl.find('.m-shop-page__name-row .shop-name').addClass('m-auto text-center');
            $shippingReturnsEl.find('.m-shop-page__name-row .shop-name').removeClass('pt-4 pt-lg-5');
            $('#sellerShippingReturnPolicyModal .seller-shipping-return-policy-modal-content').empty().html($shippingReturnsEl.html());
            $('#sellerShippingReturnPolicyModal').modal('show');
            $.spinner().stop();
        }
    });
});

/**
 * Handling click event to load the postal code input modal
 */
$(document).on('click', '.seller-ship-to', (function (e) {
    e.preventDefault();
    var actionUrl = $(this).data('url');
    getModalHtmlElement();
    fillModalElement(actionUrl);
}));

/**
 * Submit the postal code modal form
 */
$('body').on('submit', '.pdp-postalCode-form', function (e) {
    e.preventDefault();
    $('body').spinner().start();
    var shopId = $('#bestOffer-shop-id').val();
    var offerId = $('#bestOffer-id').val();
    var postalCode = $('#postal-code-input').val();

    $.ajax({
        url: $(this).attr('action'),
        data: {
            postalCode:postalCode,
            shopId: shopId,
            offerId: offerId
        },
        method: 'GET',
        success: function (response) {
            $('body').spinner().stop();
            if (!response.error) {
                // hide the modal and stop the loading spinner
                $('#inStoreInventoryModal').modal('hide');
                $('#inStoreInventoryModal').spinner().stop();

                // set the entered postal code on pdp
                $('.seller-ship-to').text(response.postalCode);

                // hide the existing shipping messages
                if(!$('.free-ship-text-mp').hasClass('d-none')){
                    $('.free-ship-text-mp').addClass('d-none');
                }
                if(!$('#ship-to-delivery-date').hasClass('d-none')){
                    $('#ship-to-delivery-date').addClass('d-none');
                }


                // show free shipping cost only if valid response from server
                if('sellerShippingCost' in response && response.sellerShippingCost !== '' && response.sellerShippingCost !== null) {
                    $('.free-ship-text-mp').removeClass('d-none');
                    $('#free-shipping-mp-seller').text(response.sellerShippingCost);
                }

                // show estimated delivery dates only if valid response from server
                if('stdDelivery' in response && response.stdDelivery !== '' && response.stdDelivery !== null) {
                    $('#ship-to-delivery-date').removeClass('d-none');
                    $('#ship-to-delivery-date').text(response.stdDelivery);
                }

            } else {
                $('.invalid-feedback').html(response.error);
                $('.btn-shipping-on-postalcode').parents('.form-group').find('label, input').addClass('is-invalid');
            }
        },
        error: function () {
            $('#inStoreInventoryModal').spinner().stop();
        }
    });
    return false;
});
/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#inStoreInventoryModal').length !== 0) {
        $('#inStoreInventoryModal').remove();
    }
    var htmlString = '<!-- Modal -->' +
        '<div class="modal inStoreInventoryModal" id="inStoreInventoryModal" role="dialog" aria-modal="true">' +
        '<div class="modal-dialog in-store-inventory-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<span class="modal-header-title"> POSTAL CODE </span>' +
        '    <button type="button" class="close svg-svg-22-cross svg-svg-22-cross-dims" data-dismiss="modal" aria-label="Close postal code modal" title="Close">' // eslint-disable-line
        +
        '    </button>' +
        '</div>' +
        '<div></div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('#inStoreInventoryModal').modal('show');
}

/**
 * Replaces the content in the modal window with find postal code components
 */
function fillModalElement(targetUrl) {
    $('#inStoreInventoryModal').spinner().start();
    $.ajax({
        url: targetUrl,
        data: {},
        method: 'GET',
        success: function (response) {

            $('.inStoreInventoryModal .modal-header .modal-header-title').empty();
            $('.inStoreInventoryModal .modal-header .modal-header-title').html(response.postalCodeModalHeader);

            $('.inStoreInventoryModal .modal-body').empty();
            $('.inStoreInventoryModal .modal-body').html(response.postalCodeHtmlResponse);

            $('#inStoreInventoryModal').modal('show');
            $('#inStoreInventoryModal').spinner().stop();
            $
            $('.form-control-label').addClass('input-focus');
            $('#inStoreInventoryModal').find('#postal-code-input').focus();
            if(response.postalCode){
                $('#postal-code-input').val(response.postalCode);
            }
        },
        error: function () {
            $('#inStoreInventoryModal').spinner().stop();
        }
    });



}
module.exports = {
    updateAttribute: updateAttribute,
    handleOfferState: handleOfferState
};
